import React, { SyntheticEvent, useCallback, useState } from "react";
import makeStyles from "@material-ui/styles/makeStyles";
import classNames from "classnames";
import { CUSTOMIZATIONS } from "../../../constants/integration/customizations";

export interface IBackgroundImage2dProps {
    url?: string;
    children?: JSX.Element[];
}

const useStyles = makeStyles({
    backgroundImage: {
        maxWidth: "100%",
        maxHeight: "100%",
        width: "100%",
        height: "100%",
        objectFit: "contain",
    },
    backgroundContainer: {
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    backgroundImageContainer: {
        position: "relative",
    },
});

export const DIRECTION_STYLE = {
    horizontal: {
        width: "100%",
        height: "auto",
    },
    vertical: {
        width: "auto",
        height: "100%",
    },
};

export const BackgroundImage2d: React.FC<IBackgroundImage2dProps> = ({ url, children }) => {
    const classes = useStyles();
    const [isVertical, setIsVertical] = useState(false);
    const handleLoad = useCallback((event: SyntheticEvent<HTMLImageElement>) => {
        const { width, height } = event.currentTarget;
        setIsVertical(height > width);
    }, []);

    if (!url) {
        return null;
    }

    return (
        <div className={classes.backgroundContainer}>
            <div
                className={classes.backgroundImageContainer}
                data-test={CUSTOMIZATIONS.CUSTOMIZATIONS_2D_BACKGROUND_CONTAINER}
                style={isVertical ? DIRECTION_STYLE.vertical : DIRECTION_STYLE.horizontal}
            >
                <img
                    onLoad={handleLoad}
                    data-test={CUSTOMIZATIONS.CUSTOMIZATIONS_2D_BACKGROUND}
                    className={classNames("background-image", classes.backgroundImage)}
                    src={url}
                    role="presentation"
                    alt="product customization background image"
                />
                {children}
            </div>
        </div>
    );
};
